import React from "react";
import { Table, OptionsDataType, ColDataType, RowDataType } from "@thrivetribe/mvf.ui.organisms.table";
import "./ScoreBreakdown.scss";

interface CellProps {
  leftContent: string;
  rightContent: string | number;
}

const Cell = ({ leftContent, rightContent }: CellProps): JSX.Element => {
  return (
    <div className="score-breakdown cell">
      <span>{leftContent}</span>
      <span>{rightContent}</span>
    </div>
  );
};

export interface ScoreBreakdownStatsProp {
  score?: number;
  hatricks?: number;
  ownGoals?: number;
  percentageBonuses?: number;
  teamBonuses?: number;
  trackingGoals?: number;
  misc?: number;
}
interface ScoreBreakdownProps {
  homeTeam: ScoreBreakdownStatsProp;
  awayTeam: ScoreBreakdownStatsProp;
}

export const ScoreBreakdown = ({ homeTeam, awayTeam }: ScoreBreakdownProps): JSX.Element => {
  const options: OptionsDataType = {
    tableAriaLabel: "Score Card",
    tablePrefixClass: "score-breakdown",
    headerEl: <span>Score Breakdown</span>,
    headerColTitlesDisabled: true,
  };

  const columns: ColDataType[] = [
    { id: "leftCol", label: "" },
    { id: "rightCol", label: "" },
  ];

  interface CustomRowDataType extends RowDataType {
    leftCol: JSX.Element;
    rightCol: JSX.Element;
  }

  const rows: CustomRowDataType[] = [
    {
      leftCol: <Cell leftContent="Score" rightContent={homeTeam.score ?? "-"} />,
      rightCol: <Cell leftContent="Score" rightContent={awayTeam.score ?? "-"} />,
    },
    {
      leftCol: <Cell leftContent="Hatricks" rightContent={homeTeam.hatricks ?? "-"} />,
      rightCol: <Cell leftContent="Hatricks" rightContent={awayTeam.hatricks ?? "-"} />,
    },
    {
      leftCol: <Cell leftContent="Own goals" rightContent={homeTeam.ownGoals ?? "-"} />,
      rightCol: <Cell leftContent="Own goals" rightContent={awayTeam.ownGoals ?? "-"} />,
    },
    {
      leftCol: <Cell leftContent="% Bonuses" rightContent={homeTeam.percentageBonuses ?? "-"} />,
      rightCol: <Cell leftContent="% Bonuses" rightContent={awayTeam.percentageBonuses ?? "-"} />,
    },
    {
      leftCol: <Cell leftContent="Team bonuses" rightContent={homeTeam.teamBonuses ?? "-"} />,
      rightCol: <Cell leftContent="Team bonuses" rightContent={awayTeam.teamBonuses ?? "-"} />,
    },
    {
      leftCol: <Cell leftContent="Tracking goals" rightContent={homeTeam.trackingGoals ?? "-"} />,
      rightCol: <Cell leftContent="Tracking goals" rightContent={awayTeam.trackingGoals ?? "-"} />,
    },
    {
      leftCol: <Cell leftContent="Misc" rightContent={homeTeam.misc ?? "-"} />,
      rightCol: <Cell leftContent="Misc" rightContent={awayTeam.misc ?? "-"} />,
    },
  ];

  return (
    <div className="score-breakdown-container">
      <Table options={options} columns={columns} rows={rows} />
    </div>
  );
};
